// homepage search
var client = algoliasearch('WSAU04X1A3', 'b31211857ef7a4712b775a6f42cacb89');
var rental = client.initIndex('wp_posts_rental');
var sales = client.initIndex('wp_posts_sales');
var submitUrl = $('.search-bar__form.form').attr('action');

autocomplete('.search-bar--home #search-input', {
    hint: false,
    debug: true,
    minWordSizefor1Typo: 1,
    minWordSizefor2Typos: 2,
    templates: {
        // dropdownMenu: '#my-custom-menu-template',
        header: (data) => {
            const template = `<div class="search-result__header">
                                <div class="search-result__suggestions">
                                    <span class="search-result__label">${translations.results_found_for}:</span>
                                </div>
                        
                                <span class="search-result__close">
                                    <i class="fa fa-fw fa-times"></i>
                                </span>
                            </div>`;
            return template;
        }
    },
    cssClasses: {
        suggestions: 'suggestions row',
        suggestion: 'suggestion small-12 columns'
    }
}, [{
        source: autocomplete.sources.hits(rental, {
            hitsPerPage: 4,
        }),
        name: 'd1',
        templates: {
            header: `<h2 class="search-result__title">${translations.rental}</h2>`,

            empty: (data) => {
                const template = `${translations.no_results_matched_query} <em>${data.query}</em>`;
                return template;
            },

            suggestion: (data) => {
                const template = `<div class="search-result__item">
                                    <div class="row">
                                        <!--<div class="search-result__image small-5 columns">
                                            <a href="${data.permalink}" title="${data.post_title}" alt="${data.post_title}">
                                                <span class="search-result__image-background" style="background-image: url('${data.product_image}');"></span>
                                            </a>
                                        </div>-->

                                        <div class="search-result__content small-12 columns">
                                            <a style="color: unset;" href="${data.permalink}"><h3 class="search-result__name">${data.post_title}</h3></a>

                                            <!--<div class="search-result__intro">${data.product_intro}</div>
                                            <div class="search-result__description">
                                                <p>${data.content}</p>
                                            </div>-->

                                            <a href="${data.permalink}" class="search-result__link" title="${data.post_title}" alt="${data.post_title}">${translations.more_information}</a>
                                        </div>
                                    </div>
                                </div>`;

                return template;
            },
        }
    },
    {
        source: autocomplete.sources.hits(sales, {
            hitsPerPage: 4,
        }),
        name: 'd2',
        templates: {
            header: `<h2 class="search-result__title">${translations.sales}</h2>`,

            empty: (data) => {
                const template = `${translations.no_results_matched_query} <em>${data.query}</em>`;
                return template;
            },

            suggestion: (data) => {
                const template = `<div class="search-result__item">
                                    <div class="row">
                                       <!-- <div class="search-result__image small-5 columns">
                                            <a href="${data.permalink}" title="${data.post_title}" alt="${data.post_title}">
                                                <span class="search-result__image-background" style="background-image: url('${data.product_image}');"></span>
                                            </a>
                                        </div> -->

                                        <div class="search-result__content small-12 columns">
                                             <a style="color: unset;" href="${data.permalink}"><h3 class="search-result__name">${data.post_title}</h3></a>

                                            <!--<div class="search-result__intro">${data.product_intro}</div>
                                            <div class="search-result__description">
                                                <p>${data.content}</p>
                                            </div>-->

                                            <a href="${data.permalink}" class="search-result__link" title="${data.post_title}" alt="${data.post_title}">${translations.more_information}</a>
                                        </div>
                                    </div>
                                </div>`;
                return template;
            },
        }
    }
]).on('autocomplete:selected', function (event, suggestion, dataset, context) {
    console.log(event, suggestion, dataset, context);
}).on('autocomplete:opened', function () {
    $('.aa-dropdown-menu').addClass('search-result');
});

autocomplete('.footer__search-bar #search-input', {
    hint: false,
    debug: true,
    templates: {
        // dropdownMenu: '#my-custom-menu-template',
        // header: '#tmpl-autocomplete-header',

        // footer: (data) => {
        //     const template = `<div class="search-result__footer">
        //                         <a href="#" class="search-result__view-more">${translations.view_all_results}</a>
        //                     </div>`;
        //
        //     return template;
        // }

        header: (data) => {
            const template = `<div class="search-result__header">
                                <div class="search-result__suggestions">
                                    <span class="search-result__label">${translations.results_found_for}:</span>
                                </div>
                        
                                <span class="search-result__close">
                                    <i class="fa fa-fw fa-times"></i>
                                </span>
                            </div>`;

            return template;
        }
    },
    cssClasses: {
        suggestions: 'suggestions row',
        suggestion: 'suggestion small-12 columns'
    }
}, [{
        source: autocomplete.sources.hits(rental, {
            hitsPerPage: 2,
        }),
        name: 'd1',
        templates: {
            header: `<h2 class="search-result__title">${translations.rental}</h2>`,

            empty: (data) => {
                const template = `${translations.no_results_matched_query} <em>${data.query}</em>`;
                return template;
            },

            suggestion: (data) => {
                const template = `<div class="search-result__item">
                                    <div class="row">
                                        <!--<div class="search-result__image small-5 columns">
                                            <a href="${data.permalink}" title="${data.post_title}" alt="${data.post_title}">
                                                <span class="search-result__image-background" style="background-image: url('${data.product_image}');"></span>
                                            </a>
                                        </div>-->

                                        <div class="search-result__content small-12 columns">
                                            <a style="color: unset;" href="${data.permalink}"><h3 class="search-result__name">${data.post_title}</h3></a>

                                            <!--<div class="search-result__intro">${data.product_intro}</div>
                                            <div class="search-result__description">
                                                <p>${data.content}</p>
                                            </div>-->

                                            <a href="${data.permalink}" class="search-result__link" title="${data.post_title}" alt="${data.post_title}">${translations.more_information}</a>
                                        </div>
                                    </div>
                                </div>`;

                return template;
            },
        }
    },
    {
        source: autocomplete.sources.hits(sales, {
            hitsPerPage: 2
        }),
        name: 'd2',
        templates: {
            header: `<h2 class="search-result__title">${translations.sales}</h2>`,

            empty: (data) => {
                const template = `${translations.no_results_matched_query} <em>${data.query}</em>`;
                return template;
            },

            suggestion: (data) => {
                const template = `<div class="search-result__item">
                                    <div class="row">
                                        <!--<div class="search-result__image small-5 columns">
                                            <a href="${data.permalink}" title="${data.post_title}" alt="${data.post_title}">
                                                <span class="search-result__image-background" style="background-image: url('${data.product_image}');"></span>
                                            </a>
                                        </div>-->

                                        <div class="search-result__content small-12 columns">
                                            <a style="color: unset;" href="${data.permalink}"><h3 class="search-result__name">${data.post_title}</h3></a>

                                            <!--<div class="search-result__intro">${data.product_intro}</div>
                                            <div class="search-result__description">
                                                <p>${data.content}</p>
                                            </div>-->

                                            <a href="${data.permalink}" class="search-result__link" title="${data.post_title}" alt="${data.post_title}">${translations.more_information}</a>
                                        </div>
                                    </div>
                                </div>`;

                return template;
            },
        }
    }
]).on('autocomplete:selected', (event, suggestion, dataset, context) => {
    console.log(event, suggestion, dataset, context);
}).on('autocomplete:opened', () => {
    $('.aa-dropdown-menu').addClass('search-result');
});

if ($('.products .products__holder .products__list').length) {
    // Get current category
    var catname = $('.products').attr('data-slug');

        // Initiate Algolia instantsearch
        const categorySearch = instantsearch({
            appId: 'WSAU04X1A3',
            apiKey: 'b31211857ef7a4712b775a6f42cacb89',
            indexName: 'wp_posts_sales',
            routing: true,
            minWordSizefor1Typo: 2,
            minWordSizefor2Typos: 3,
            searchParameters: {
                hitsPerPage: 10,
                facetFilters: 'taxonomies.cat_sales:' + catname,
            }
        });

        const searchBox = instantsearch.widgets.searchBox({
            container: '.products__filter-input'
        });

        const hits = instantsearch.widgets.hits({
            container: '.products__holder .products__list',
            templates: {
                empty: () => {
                    const template = `<div class="products__item small-12 column">
                                        <div class="products__no-results">
                                            <h4 class="products__no-results-title">${translations.no_results_title}</h4>

                                            <div class="products__no-results-text">
                                                <p>${translations.no_results_text}<p>
                                            </div>
                                        </div>
                                    </div>`;
                    return template;
                },

                item: (data) => {

                    var postData = {
                        ID: data.post_id
                    };

                    var lift_height = data.Maximum_lift_height / 100;
                    var lift_capacity = data.Maximum_lift_capacity / 1000;

                    let template = `<div class="products__item small-12 column">
                                        <div class="row">
                                            <div class="products__image small-12  columns">
                                                <a href="${data.permalink}" title="${data.post_title}">
                                                    <span class="products__image-background" style="background-image: url('${data.product_image}');"></span>
                                                </a>
                                            </div>

                                            <div class="products__right small-12 columns">
                                                <div class="products__content">
                                                    <h4 class="products__name">
                                                        <a href="${data.permalink}" title="${data.post_title}">${data.post_title}</a>

<!--                                                        <span class="price">${data.product_second}</span>-->
                                                    </h4><div class="products__description">`;

                    if(typeof data.product_first !== 'undefined') {
                        template += `<div class="product_item"><div class="name">Year:</div><div class="value">${data.product_first}</div></div>`;
                    }

                    if(typeof data.Hours_of_use !== 'undefined') {
                        template += `<div class="product_item"><div class="name">Hours of use:</div><div class="value">${data.Hours_of_use}h</div></div>`;
                    }

                    if(typeof data.Maximum_lift_height !== 'undefined' && lift_height > 0) {
                        var mlh = lift_height * 100 ;
                        template += `<div class="product_item"><div class="name">Maximum lift height:</div><div class="value">${ mlh.toFixed() }m</div></div>`;
                    }

                    if(typeof data.Maximum_lift_capacity !== 'undefined' && lift_capacity > 0) {
                        // num.toFixed(2)
                        var lc = lift_capacity * 1000 ;
                        template += `<div class="product_item"><div class="name">Maximum lift capacity:</div><div class="value">${ lc.toFixed() }ton</div></div>`;
                    }

                    if(data.product_second == 'On request'){
                        data.product_second = 'More information';
                    }
                    
                    template += `</div> <div class="products__buttons">
                                                    <a href="${data.permalink}" title="${data.post_title}" class="product-single-a">${data.product_second}</a>
                                                </div></div>

                                               
                                            </div> 
                                        </div>
                                    </div>`;
                    return template;
                }
            }
        });

        const brandRefined = instantsearch.widgets.refinementList({
                container: '#brand-refinement',
                attributeName: 'Brand',
                collapsed: false,
                collapsible: true,
                templates: {
                    header: () => {
                        const template = `<span>${translations.brands}</span> <i class="fa fa-fw fa-caret-up"></i>`;
                        return template;
                    }
                }
            });

        const pagination = instantsearch.widgets.pagination({
            container: '.products__pagination',
        });

        const menu = instantsearch.widgets.hierarchicalMenu({
             container: '#category-menu',
             attributes: [
                 'taxonomies_hierarchical.cat_sales.lvl0',
                 'taxonomies_hierarchical.cat_sales.lvl1',
                 'taxonomies_hierarchical.cat_sales.lvl2',
             ],
             collapsed: false,
             collapsible: true,
             cssClasses: {
                 root: 'root',
                 childList: 'childList',
                 parentItem: 'parentItem',
                 selectedItem : 'selected',
                 count: 'count-label'
             },
             templates: {
                 header: function() {
                     var template = '<span>' + translations.categories + '</span> <i class="fa fa-fw fa-caret-up"></i>';

                     return template;
                 }
             }
        });

        const clearFilter = instantsearch.widgets.clearAll({
                container: '#clear-all',
                templates: {
                    link: function() {
                        var template = '<i class="fas fa-sync-alt"></i> <span>' + translations.clear_filters + '</span>';

                        return template;
                    }
                },
            });

        categorySearch.addWidgets([searchBox, hits, pagination, brandRefined, clearFilter, menu]);

        categorySearch.start();

        categorySearch.on('error', (res) => {
            console.log('error', res);
        });
    
}

//////////////////////////////////////////
/*
if ($('#search-input_overview').length) {

    var category = $('.page_category').attr('data-value');
    var topic = $('.page_topic').attr('data-value');

    filter_txt = 'wpml.locale:"' + global.current_locale + '"';

    if (category.length > 0) {
        filter_txt = 'wpml.locale:"' + global.current_locale + '" AND taxonomies.speaker_category:"' + category + '"';
    }

    if (topic.length > 0) {
        filter_txt = 'wpml.locale:"' + global.current_locale + '" AND taxonomies.topic:"' + topic + '"';
    }

    console.log(filter_txt);

    // search page overview
    var search = instantsearch({
        // Replace with your own values
        appId: 'ZGGSNUFEL4',
        apiKey: '7cf0b412ff5a4f711949334c04f6f738',
        indexName: 'wp_posts_sales',
        routing: true,
        searchParameters: {
            hitsPerPage: 15,
            filters: filter_txt
        }
    });

    search.addWidget(
        instantsearch.widgets.searchBox({
            container: '#search-input_overview'
        })
    );

    if (global.current_locale == 'nl_NL') {
        var more_info = 'Meer informatie';
        var read_more = 'Lees verder';
        var results = 'resultaten';
        var no_results = 'Niet alle sprekers en onderwerpen staan op onze website. Neem voor meer informatie en advies contact met ons op via info@speakersacademy.nl.';
    } else {
        var read_more = 'Read more';
        var more_info = 'More information';
        var results = 'results';
        var no_results = "We didn't find any results for the search <em>\"{{query}}\"</em>";
    }

    search.addWidget(
        instantsearch.widgets.infiniteHits({
            container: '#hits',
            cssClasses: {
                root: 'sprekers-container-men overview-page',
                item: 'sprekers-container-men-item',
                active: 'active'
            },
            templates: {
                item: function (data) {
                    item = '<a href="' + data.permalink + '">';
                    item += '<div class="speakers-slide-block" style="background-image: url(' + data.profile_image + ');">';
                    item += '<div class="speakers-slide-lang"></div><div class="speakers-slide-data">';
                    item += '<div class="speakers-slide-name">' + data.post_title + '</div>';
                    item += '<div class="speakers-slide-info"><span>' + data.title + '</span>';
                    item += '<div class="speakers-slide-topics">';

                    var topics = data.taxonomies.topic;

                    var topic_string = '';
                    $.each(topics, function (i, val) {
                        topic_string += val + ', ';

                        if (i == 3) {
                            return false;
                        }
                    });

                    topic_string = topic_string.slice(0, -2);

                    item += topic_string + '</div>';

                    item += '<div class="btn">' + more_info + '</div></div></div></div></a>';

                    return item;
                },
                empty: no_results
            },
            escapeHits: false,
            showMoreLabel: 'Toon meer sprekers'
        })
    );

    search.addWidget(
        instantsearch.widgets.refinementList({
            container: '#category-refinement',
            attributeName: 'taxonomies.speaker_category',
            limit: 999,
            sortBy: ["name:asc"],
            cssClasses: {
                root: 'icheck-inp-overzitcht'
            }
        })
    );

    search.addWidget(
        instantsearch.widgets.refinementList({
            container: '#topic-refinement',
            attributeName: 'taxonomies.topic',
            limit: 999,
            sortBy: ["name:asc"],
            cssClasses: {
                root: 'icheck-inp-overzitcht'
            }
        })
    );

    search.addWidget(
        instantsearch.widgets.refinementList({
            container: '#languages-refinement',
            attributeName: 'taxonomies.languages',
            limit: 999,
            sortBy: ["name:asc"],
            cssClasses: {
                root: 'icheck-inp-overzitcht'
            }
        })
    );

    search.addWidget(
        instantsearch.widgets.refinementList({
            container: '#employability-refinement',
            attributeName: 'taxonomies.employability',
            limit: 999,
            sortBy: ["name:asc"],
            RefinementListItemData: {
                count: false
            },
            cssClasses: {
                root: 'icheck-inp-overzitcht'
            }
        })
    );

    search.addWidget(
        instantsearch.widgets.refinementList({
            container: '#gender-refinement',
            attributeName: 'gender',
            cssClasses: {
                root: 'icheck-inp-overzitcht'
            },
            templates: {
                item: function (e) {

                    if (global.current_locale == 'nl_NL') {
                        if (e.label == 'male') {
                            value = 'Man';
                        } else {
                            value = 'Vrouw';
                        }
                    } else {
                        value = e.label;
                    }

                    value = '<label>' + value + '</label>';

                    return value;
                },
            },
        })
    );

    search.addWidget(
        instantsearch.widgets.numericRefinementList({
            container: '#price',
            attributeName: 'price',
            operator: 'or',
            autoHideContainer: true,
            options: [{
                    name: 'Alles'
                },
                {
                    start: 500,
                    end: 1000,
                    name: '500 tot 1.000'
                },
                {
                    start: 1000,
                    end: 2000,
                    name: '1.000 tot 2.000'
                },
                {
                    start: 2000,
                    end: 3000,
                    name: '2.000 tot 3.000'
                },
                {
                    start: 3000,
                    end: 4000,
                    name: '3.000 tot 4.000'
                },
                {
                    start: 4000,
                    end: 5000,
                    name: '4.000 tot 5.000'
                },
                {
                    start: 5000,
                    end: 7500,
                    name: '5.000 tot 7.500'
                },
                {
                    start: 7500,
                    end: 15000,
                    name: '7.500 tot 15.000'
                },
                {
                    start: 15000,
                    name: '15.000 en meer'
                }
            ]
        })
    );

    search.addWidget(
        instantsearch.widgets.clearAll({
            container: '#clear-all',
            templates: {
                link: 'Wis filters'
            },
            autoHideContainer: false,
            clearsQuery: true,
        })
    );

    search.start();

    ////////// blogs and videos search
    var category = $('.page_category').attr('data-value');
    var topic = $('.page_topic').attr('data-value');

    filter_txt = 'wpml.locale:"' + global.current_locale + '"';

    if (category.length > 0) {
        filter_txt = 'wpml.locale:"' + global.current_locale + '" AND taxonomies.speaker_category:"' + category + '"';
    }

    if (topic.length > 0) {
        filter_txt = 'wpml.locale:"' + global.current_locale + '" AND taxonomies.topic:"' + topic + '"';
    }

    // search page overview
    var blog_search = instantsearch({
        // Replace with your own values
        appId: 'ZGGSNUFEL4',
        apiKey: '7cf0b412ff5a4f711949334c04f6f738',
        indexName: 'wp_posts_post',
        routing: true,
        searchParameters: {
            hitsPerPage: 5,
            filters: filter_txt
        }
    });


    blog_search.on('render', function () {
        if (!$('#blogs_news .ais-infinite-hits--item').length) {
            $('.overview-blog').hide();
        }

        $('.liquid').imgLiquid();
        $('.blog-news-short').matchHeight();
    });

    blog_search.addWidget(
        instantsearch.widgets.searchBox({
            container: '#search-input_overview'
        })
    );

    if (global.current_locale == 'nl_NL') {
        var more_info = 'Meer informatie';
        var results = 'resultaten';
    } else {
        var more_info = 'More information';
        var results = 'results';
    }

    blog_search.addWidget(
        instantsearch.widgets.infiniteHits({
            container: '#blogs_news',
            cssClasses: {
                root: '',
                item: '',
                active: 'active'
            },
            templates: {
                item: function (data) {
                    console.log(data);
                    item = '';
                    if (data.__hitIndex < 2) {
                        item += '<div class="blog-news-item2">';
                        item += '<div class="blog-news-big-short';

                        if (data.video.length > 0) {
                            item += ' video ';
                        }

                        item += ' liquid">';
                        item += data.item_image;
                        item += '<div class="blog-n-b-s-info">';
                        item += '<span>' + data.formated_date + '</span>';
                        item += '<h3>' + data.post_title + '</h3>';
                        item += '<p>' + data.content_short + '...</p>';
                        item += '</div>';
                        item += '<a href="' + data.permalink + '"></a>';
                        item += '</div></div>';

                    } else {
                        item += '<div class="blog-news-item">';
                        item += '<div class="blog-news-short" data-mh="blog-short-box">';
                        item += '<h3 data-mh="blog-short-title">' + data.post_title + '</h3>';
                        item += '<p>' + data.content_short + '...</p>';
                        item += '<span>' + read_more + '</span>';
                        item += '<a href="' + data.permalink + '"></a>';
                        item += '</div>';
                        item += '</div>';
                    }

                    return item;
                },
                empty: ''
            },
            escapeHits: false,
            showMoreLabel: 'Toon meer items'
        })
    );

    blog_search.start();

} */